import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";
import {CalendarViewType, League, LeagueStatus, Lookups} from "@model";
import {AbstractComponent} from "../abstract.component";
import {environment} from "@environment";

@Component({
    selector: 'app-league-grid-item',
    templateUrl: './league-grid-item.component.html',
    styleUrls: ['./league-grid-item.component.scss'],
    standalone: false
})
export class LeagueGridItem extends AbstractComponent {
  @Input() league: League | undefined;
  @Input({required: true}) languages: Lookups[] = [];
  @Output() onRightButtonClickCallback = new EventEmitter<League>();
  currentLayout: CalendarViewType = CalendarViewType.LIST;

  constructor(public translocoService: TranslocoService) {
    super();
  }


  ngOnInit() {
    this.updateLayout();
    this.subscriptions.push(
        this.isMobile$.subscribe(() => this.updateLayout()),
        this.isMdScreen$.subscribe(() => this.updateLayout())
    );
  }

  onRightButtonClick() {
    this.onRightButtonClickCallback.emit();
  }

  private updateLayout(): void {
    this.currentLayout = this.isMdScreen || this.isMobile ? CalendarViewType.GRID : CalendarViewType.LIST
  }


  protected readonly environment = environment;
  protected readonly LeagueStatus = LeagueStatus;
  protected readonly CalendarViewType = CalendarViewType;
}
